import { useQuery } from '@tanstack/react-query';
import dailySiteReportService from '@services/dailySiteReport';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

export const DAILY_SITE_REPORT_SETTINGS_QUERY_KEY = 'dailySiteReportSettings';

export const useDailySiteReportSettings = (enabled = true) => {
  const { organizationId } = useAppSelector((state: RootState) => state.organization);

  return useQuery({
    queryKey: [DAILY_SITE_REPORT_SETTINGS_QUERY_KEY, organizationId],
    queryFn: () => dailySiteReportService.getDailySiteReportSettings(),
    enabled: !!organizationId && enabled,
  });
};

export default useDailySiteReportSettings;
